import * as React from 'react';
import { useForm } from 'react-hook-form';
import { useNavigate } from 'react-router-dom';
import Form from 'react-bootstrap/Form';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import Button from '@mui/material/Button';
import Stack from '@mui/material/Stack';
import CircularProgress from '@mui/material/CircularProgress';
import toast from 'react-hot-toast';
import { postRequest } from '../../../lib/api';
import { useContext } from 'react';
import { AuthContext } from '../../../authContext/context';
import BreadcrumbsWrapper from '../../../components/breadcrumbs'

// Redux imports
import { useDispatch } from 'react-redux';
import { addProduct } from '../../../redux/slices/productSlice';

export default function CreateProduct() {
  const {
    register,
    handleSubmit,
    formState: { errors },
    reset
  } = useForm();

  const navigate = useNavigate();
  const authCtx = useContext(AuthContext);
  const [loading, setLoading] = React.useState(false);

  const dispatch = useDispatch();

  const onSubmit = async (data) => {
    setLoading(true);
    try {
      // Only send required keys to API
      const payload = {
        title: data?.title,
      };
      const response = await postRequest('private/createProduct', payload, authCtx.token);
      console.log(response , 'response')
      if (response?.status == 200) {
        //toast.success('Product created successfully!');
        dispatch(addProduct(response?.data));
        reset();
        navigate('/products');
      } else {
        //toast.error(response?.message || 'Product creation failed');
      }
    } catch (err) {
      //toast.error(err?.message || 'Something went wrong');
    } finally {
      setLoading(false);
    }
  };

  return (
    <>
        <BreadcrumbsWrapper
                                  items={[
                                    { label: 'Dashboard', path: '/dashboard' },
                                    { label: 'Products', path: '/products' },
                                    { label: 'Add Product', path:'' },
                                   
                                  ]}
                                />
                          <br></br>
      <div className="page-header">
     
        <h1 className="mt-0">Add New Product</h1>
      </div>

      <div className="page-top-formview mb-3">
        <Form onSubmit={handleSubmit(onSubmit)}>
          <Row className="mb-3">
            <Form.Group as={Col} controlId="title">
              <Form.Label>Title</Form.Label>
              <Form.Control
                type="text"
                placeholder="Title of product"
                {...register('title', { required: 'Title is required' })}
                isInvalid={!!errors.title}
              />
              <Form.Control.Feedback type="invalid">
                {errors.title?.message}
              </Form.Control.Feedback>
            </Form.Group>
          </Row>

          <Stack direction="row" spacing={2}>
            <Button variant="outlined" color="inherit" type="button" onClick={() => navigate(-1)}>
              Cancel
            </Button>
            <Button variant="contained" className='red-bg red-button text-capitalize' type="submit" disabled={loading}>
              {loading ? <CircularProgress size={20} color="inherit" /> : 'Submit'}
            </Button>
          </Stack>
        </Form>
      </div>
    </>
  );
}